import { useState, useEffect } from 'react'
import { Text, Icon, Image, CustomLink } from 'components/common'

import { diffForHumans } from 'helpers/_functions'

const NotifyItem = ({ not }) => {

    const [view, setView] = useState({
        title: null,
        subtitle: null,
        link: null,
        createdAt: null
    })

    const iconType = {
        'comment-like': (
            <Icon className='op-heart'>
                <span className='path1'></span>
                <span className='path2'></span>
            </Icon>
        ),
        'feedback-like': (
            <Image src={`/images/reviewSvgs/${not.data?.like?.type}.svg`} />
        ),
        'comment': (
            <Icon className='op-message darkGrey' />
        ),
        'feedback-debate': (
            <Icon className='op-messages darkGrey' />
        ),
        'feedback-child': (
            <Icon className='op-messages darkGrey' />
        ),
        'follow': (
            <Icon className="op-personArrowLeft" />
        ),
        'invite': (
            <Icon className='op-messages darkGrey' />
        )
    }

    useEffect(() => {
        const type = not.type;
        let title, subtitle, link = '/';
        const username = `${not.data.user?.name} ${not.data.user?.surname}`

        if (type == 'comment-like') {
            title = 'Someone liked your comment'
            subtitle = not.data.text
            link = not.data.feedback?.parent_id == null ? `/debate/${not.data.debate?.slug}` : `/feedback/${not.data.feedback?.parent_id}`
        } else if (type == 'follow') {
            title = `${username} started following you`
            link = `/${not.data.user?.username}`
        } else if (type == 'feedback-like') {
            title = 'Someone reacted to your statement'
            subtitle = not.data.feedback.text
            link = not.data.feedback.parent_id == null ? `/debate/${not.data.feedback.debate.slug}` : `/feedback/${not.data.feedback.parent_id}`
        } else if (type == 'comment') {
            title = `${username} commented under your statement`
            subtitle = not.data.feedback.text
            link = not.data.feedback.parent_id == null ? `/debate/${not.data.debate?.slug}` : `/feedback/${not.data.feedback.parent_id}`
        } else if (type == 'feedback-debate') {
            if (not.data.feedback.type == 'pro') {
                title = `${username} added pro argument to your debate`
            } else {
                title = `${username} added con argument to your debate`
            }
            subtitle = not.data.debate.title
            link = `/debate/${not.data.debate.slug}`
        } else if (type == 'feedback-child') {
            if (not.data.child.type == 'pro') {
                title = `${username} added pro argument to your statement`
            } else {
                title = `${username} added con argument to your statement`
            }
            subtitle = not.data.parent.text
            link = `/feedback/${not.data.parent.id}`
        } else if (type == 'invite') {
            title = not.data.debate.isPublic ? `${username} invited you to debate` : `${username} invited you to private debate`
            subtitle = not.data.debate.title
            link = `/debate/${not.data.debate.slug}`
        }

        setView({
            title,
            subtitle,
            link,
            createdAt: diffForHumans(not.created_at)
        })
    }, [not])

    return view.link ? (
        <CustomLink url={view.link}>
            <div className='single-not flexBox'>
                {iconType[not.type]}
                <div className='info flexBoxColumn'>
                    <Text
                        tag='h6'
                        className='h6 PopReg'
                        text={view.title}
                    />
                    {view.subtitle && (
                        <Text
                            tag='h6'
                            className='h6 PopSemi text'
                            text={view.subtitle}
                        />
                    )}
                    <Text
                        tag='p'
                        className='h8 PopReg grey'
                        text={view.createdAt}
                    />
                </div>
            </div>
        </CustomLink>
    ) : null
}

export default NotifyItem